import { createRouter, createWebHistory } from 'vue-router'
import MenuDesign from '@/views/menuDesignView'
// import MenuDesign from '@/views/nestableDesignView'
import LiveView from '@/views/liveView'
import ActionLogs from '@/views/actionLogView'
import CreateApp from '@/views/createApp'
import AccountProfile from '../views/accountProfile.vue'
import ProvisionShortCodeExtension from '@/views/provisionExtension'
import ShortCodeProviders from '@/views/shortCodeProviders'
import BuyShortCode from '@/views/buyShortCode'
import ConnectAppToShortCode from '@/views/connectAppToShortcode'
import MyShortCodes from '@/views/myShortCodes'
import AppList from '@/views/appsList'
import AppsListAdmin from '@/views/appsListAdmin'
import AppTemplates from '@/views/appTemplates'
import AccountBilling from '@/views/accountBilling'
import AppSettings from '@/views/editAppSettings'
import CompleteSession from '@/views/completeSession'
import UncompleteSession from '@/views/uncompleteSession'
import Search from '@/views/search'
import Emulator from '@/views/emulatorView'
import EmulatorForTemplates from '@/views/emulatorForTemplates'
import Dashboard from '@/views/dashboard.vue'
import Home from '@/views/Home.vue'
import FAQ from '@/views/faq.vue'
import About from '@/views/About.vue'
import Contact from '@/views/contact.vue'
import Pricing from '@/views/pricing.vue'
import getStarted from '@/components/get-started.vue'
import WhatsappBotList from '@/views/whatsappBotList'
import BotDesigner from '@/components/whatsappBot/BotDesigner'
import BotSettings from '@/components/whatsappBot/BotSettings'
import CustomFunctionEdtitView from '@/views/customFunctionEdit.vue'
import CustomFunctionsListView from '@/views/customFunctionsListView.vue'
import ApiKeys from '@/views/apiKeys.vue'
import Logout from '@/views/logout.vue'

// Import merchant views
import MerchantList from '@/views/merchant/MerchantList.vue'
import MyMerchants from '@/views/merchant/MyMerchants.vue'
import RegisterMerchant from '@/views/merchant/RegisterMerchant.vue'
import MerchantUsers from '@/views/merchant/MerchantUsers.vue'
import MerchantLogin from '@/views/merchant/MerchantLogin.vue'
import MerchantTransactions from "@/views/merchant/MerchantTransactions.vue"

// Import user views
import UserList from '@/views/admin/UserList.vue'
import CreateAdmin from '@/views/admin/CreateAdmin.vue'
import ManageAdmin from '@/views/admin/ManageAdmin.vue'

const routes = [
  {
    path: '/',
   
    component: () => import('../layouts/websiteLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
      },
    ],
  },
  {
    path: '/faq',
    component: () => import('../layouts/websiteLayout.vue'),
    children: [
      {
        path: '',
        name: 'Faq',
        component: FAQ,
      },
    ],
  },
  {
    path: '/pricing',
   
    component: () => import('../layouts/websiteLayout.vue'),
    children: [
      {
        path: '',
        name: 'Pricing',
        component: Pricing,
      },
    ],
  },
  {
    path: '/about',
   
    component: () => import('../layouts/websiteLayout.vue'),
    children: [
      {
        path: '',
        name: 'About',
        component: About,
      },
    ],
  },
  {
    path: '/contact',
   
    component: () => import('../layouts/websiteLayout.vue'),
    children: [
      {
        path: '',
        name: 'Contact',
        component: Contact,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/forgot_password.vue')
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('../views/reset_password.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/app/design/:id',  
    component: () => import('../layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'appdesign',
        component: MenuDesign,
      },
    ],
  },
  {
    path: '/account-profile',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'AccountProfile',
        component: AccountProfile,
      },
    ],
  },
  {
    path: '/create-app',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'CreateApp',
        component: CreateApp,
      },
    ],
  },
  {
    path: '/buy-shortcode',
   
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'BuyShortCode',
        component: BuyShortCode,
      },
    ],
  },
  {
    path: '/provision-shortcode',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'ProvisionShortCode',
        component: ProvisionShortCodeExtension,
      },
    ],
  },
  {
    path: '/shortcode-providers',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'ShortCodeProviders',
        component: ShortCodeProviders,
      },
    ],
  },

  {
    path: '/my-shortcodes',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'MyShortCodes',
        component: MyShortCodes,
      },
    ],
  },
  {
    path: '/connect-shortcode/:id',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'ConnectAppToShortCode',
        component: ConnectAppToShortCode,
      },
    ],
  },
  {
    path: `/app/liveview/:id`,
    component: () => import('../layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'LiveView',
        component: LiveView,
      },
    ],
  },
  {
    path: `/app/actionlogs/:id`,
    component: () => import('../layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'ActionLogs',
        component: ActionLogs,
      },
    ],
  },
  {
    path: `/app/completesession/:id`,
    component: () => import('../layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'CompletedSession',
        component: CompleteSession,
      },
    ],
  },
  {
    path: `/app/uncompletedsession/:id`,
    component: () => import('../layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'UncompletedSession',
        component: UncompleteSession,
      },
    ],
  },

  {
    path: '/app-settings/:id',
   
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'Settings',
        component: AppSettings,
      },
    ],
  },
  {
    path: '/app-list',
   
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'AppList',
        component: AppList,
      },
    ],
  },
  {
    path: '/app-list-admin',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'AppListAdmin',
        component: AppsListAdmin,
      },
    ],
  },
  {
    path: '/app-templates',
   
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'AppTemplates',
        component: AppTemplates,
      },
    ],
  },
  {
    path: '/account-billing',
   
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'AccountBilling',
        component: AccountBilling,
      },
    ],
  },
  {
    path: '/app/search/:id',
    
    component: () => import('../layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'Search',
        component: Search,
      }
    ]
  },
  {
    path: '/app/dashboard/:appId',
    component: () => import('../layouts/AppLayout.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
      }
    ]
  },
  {
    path: '/get-started',
    
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'GetStarted',
        component: getStarted,
      }
    ]
  },
  {
    path: '/app/emulator/:appId',
    name: 'Emulator',
    component: Emulator
  },
  {
    path: '/apptemplate/emulator/:appId',
    name: 'EmulatorForTemplates',
    component: EmulatorForTemplates
  },
  {
    path: '/whatsapp-bots',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'WhatsappBotList',
        component: WhatsappBotList,
      },
    ],
  },
  {
    path: '/whatsapp-bot/design/:id',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'BotDesigner',
        component: BotDesigner,
      },
    ],
  },
  {
    path: '/whatsapp-bot/settings/:id',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'BotSettings',
        component: BotSettings,
      },
    ],
  },
  {
    path: '/custom-functions',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'CustomFunctionsList',
        component: CustomFunctionsListView,
      },
      {
        path: ':id',
        name: 'CustomFunctionsEdit',
        component: CustomFunctionEdtitView,
      },
    ],
  },
  {
    path: '/api-keys',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'ApiKeys',
        component: ApiKeys,
      },
    ],
  },

  // Merchant routes
  {
    path: '/merchant/list',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'MerchantList',
        component: MerchantList,
      },
    ],
  },
  {
    path: '/merchant/my-merchants',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'MyMerchants',
        component: MyMerchants,
      },
    ],
  },
  {
    path: '/merchant/register',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'RegisterMerchant',
        component: RegisterMerchant,
      },
    ],
  },
  {
    path: '/merchant/list-users/:merchantUuid',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'MerchantUsers',
        component: MerchantUsers,
      },
    ],
  },
  {
    path: '/merchant/profile/:merchantUuid',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'MerchantProfile',
        component: () => import('../views/merchant/ManageMerchant.vue'),
      },
    ],
  },
  {
    path: '/merchant/manage-account',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'ManageMerchantAccount',
        component: () => import('../views/merchant/ManageMerchant.vue'),
      },
    ],
  },
  {
    path: '/merchant/login',
    name: 'MerchantLogin',
    component: MerchantLogin
  },
  {
    path: '/merchant/trxns/:merchantUuid',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'MerchantTransactionsMerchantUuid',
        component: MerchantTransactions
      },
    ],
  },
  {
    path: '/merchant/trxns',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'MerchantTransactions',
        component: MerchantTransactions
      },
    ],
  },

  // User management routes
  {
    path: '/admin/list',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'UserList',
        component: UserList,
      },
    ],
  },
  {
    path: '/admin/create',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'CreateAdmin',
        component: CreateAdmin,
      },
    ],
  },
  {
    path: '/admin/manage/:adminUuid',
    component: () => import('../layouts/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'ManageAdmin',
        component: ManageAdmin,
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

